import {stringToArrayBuffer} from '@angular/http/src/http_utils';

export namespace EmploymentStatus {
  export interface Model {
    __str__: string;
    pk: number;
    das_id: number;
    alias: string;
    name: string;
    sequence: number;
  }

  export type Alias = string;

  // Common Records, hence, may not be limited to these
  export enum KnownStatuses {
    looking = 'looking',
    pre_employment = 'pre_employment',
    done_requirements = 'done_requirements',
    balik_manggagawa = 'balik_manggagawa',
    working_flyback = 'working_flyback',
    sea_signed = 'sea_signed',
    sea_onboard = 'sea_onboard',
    working = 'working',
    others = 'others',
  }
}
